import { useKeycloak } from 'all-in-one-react-keycloak';
import { useUpdatePassword } from 'all-in-one-shared-api';
import { message } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useMessageMutilingual } from 'utils/messageMultilingual';
import { ChangePasswordForm, ChangePasswordFormData } from './ChangePasswordForm';
import { ChangePasswordMenu } from './ChangePasswordMenu';

const Wrapper = styled.div`
  padding: 12px 20px;
  display: flex;
  align-content: center;
  gap: 6px;
  background-color: #fff;

  & > * {
    max-width: 400px;
  }
`;

const Password = () => {
  const { t } = useTranslation();
  const [isUpdating, setIsUpdating] = useState(false);
  const { keycloak } = useKeycloak();
  const [state, setState] = useState<ChangePasswordFormData>({
    currentPassword: '',
    newPassword: '',
  });
  const { messageMulti } = useMessageMutilingual();
  const errorMapping: Record<string, string> = {
    'setting.password.history.exist': 'auth.password.history.exist',
    'setting.same.password': 'auth.password.history.exist',
    'setting.invalid.password': 'changePassword.error.invalidNewPassword',
    'setting.worst.password': 'auth.password.worst',
  };
  const {
    shouldFetch: updatePasswordShouldFetch,
    isLoading,
    mutate,
  } = useUpdatePassword(`updatePassword`, state.newPassword, state.currentPassword, keycloak.token ?? '', {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    onSuccess: () => {
      updatePasswordShouldFetch(false);
      message.success(t('updatePassword.success.message'));
    },
    onError: (err) => {
      updatePasswordShouldFetch(false);
      let errorMessage = err.message;
      if (errorMapping[err.code]) {
        errorMessage = errorMapping[err.code];
      }
      messageMulti.error(errorMessage);
    },
  });

  const onFinish = (values: ChangePasswordFormData) => {
    setState(values);
    updatePasswordShouldFetch(true);
    mutate();
  };

  return (
    <Wrapper>
      {isUpdating ? (
        <ChangePasswordForm isLoading={isLoading} handleOnCancel={setIsUpdating} handleOnFinish={onFinish} />
      ) : (
        <ChangePasswordMenu handleOnUpdate={setIsUpdating} />
      )}
    </Wrapper>
  );
};

export default Password;
